import React from 'react';
import { useSelector, useDispatch, shallowEqual } from 'react-redux';
import { Button } from '@surfline/quiver-react';
import { getMeter } from '@surfline/web-common';
import FeatureMatrix from '../FeatureMatrix';
import { showForm as navigate } from '../../../../actions/navigation';

const Home = () => {
  const dispatch = useDispatch();
  const meter = useSelector(getMeter, shallowEqual);
  const { treatmentVariant } = meter || {};
  const headerText =
    treatmentVariant === 'surf_check' ? 'Introducing Surf Checks' : 'Get more with a Free Account';
  const subHeaderText =
    treatmentVariant === 'surf_check'
      ? 'With Surf Checks, you get more Premium features and more waves'
      : 'With an account, you get more Premium features and more waves';
  const handleNavigation = (showForm) => dispatch(navigate(showForm));
  return (
    <div style={{ width: '100%' }}>
      <div className="sl-meter-bottom-sheet-home__container">
        <h1 className="sl-meter-bottom-sheet-home__header">{headerText}</h1>
        <h4 className="sl-meter-bottom-sheet-home__subheader">{subHeaderText}</h4>
        <FeatureMatrix />
        <div className="sl-meter-bottom-sheet-home__actions">
          <Button onClick={() => handleNavigation('createAccount')}>CREATE FREE ACCOUNT</Button>
          <div className="sl-meter-bottom-sheet-home__signin__label">
            Already have an account?
            <button
              type="button"
              onClick={() => handleNavigation('signIn')}
              className="sl-meter-bottom-sheet-home__signin__button"
            >
              Sign In.
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Home;
